export default __webpack_public_path__ + "static/media/me-with-house.a6b0ff18.jpg";